import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { RejectionComment } from '../models/RejectionComment';

export default class RejectionStoreTest {
  rejectionRegistry = new Map<string, RejectionComment>();
  selectedRejection: RejectionComment | undefined = undefined;
  loadingInitial = false;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }
  get rejectionitemsByDate() {
    return Array.from(this.rejectionRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setRejection = (Rejection: RejectionComment) => {
    this.rejectionRegistry.set(Rejection.id, Rejection);
  };

  private getRejection = (id: string) => {
    return this.rejectionRegistry.get(id);
  };

  loadRejections = async () => {
    this.loadingInitial = true;
    try {
      const rejectionDetails = await agent.Reject.list();
      rejectionDetails.forEach((rejectionDetails) => {
        runInAction(() => {
          this.setRejection(rejectionDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadRejectionById = async (id: string) => {
    const RejectionDetail = this.getRejection(id);
    if (RejectionDetail) {
      this.selectedRejection = RejectionDetail;
      return RejectionDetail;
    } else {
      this.loadingInitial = true;
      try {
        const Rejection = await agent.Reject.details(id);
        this.setRejection(Rejection);
        runInAction(() => {
          this.selectedRejection = Rejection;
        });
        this.setLoadingInitial(false);
        return Rejection;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  updateReject = async (data: any) => {
    try {
      await agent.Reject.createResolve(data);
      runInAction(() => {
        this.rejectionRegistry.set(data.id, data);
        this.selectedRejection = data;
      });
      toast.success('Resolve Message Updated Successfully ');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
